import { EventEmitter, Output } from '@angular/core';
import { OdgEvaluationNote } from '../models/odg.model';

export abstract class SmileyBase {
  // Input
  abstract activeNote: OdgEvaluationNote;
  abstract readonly: boolean;
  // Output
  abstract smileyClick: EventEmitter<OdgEvaluationNote>;
  abstract note: OdgEvaluationNote;

  public onSmileyClick() {
    this.smileyClick.emit(this.note);
  }

  get isActive(): boolean {
    return this.activeNote === this.note;
  }

  get isUnEvaluated(): boolean {
    return this.activeNote == null || this.activeNote === OdgEvaluationNote.None
  }

  get isUnselected(): boolean {
    return !this.isUnEvaluated && !this.isActive;
  }

}
